import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { DynamicForm } from '../../../interfaces/dynamic-form';
import { FormParams } from '../../../interfaces/form-params';
import { FormControl } from '@angular/forms';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'bm-daterange-form',
  templateUrl: './daterange-form.component.html',
  styleUrls: ['./daterange-form.component.scss']
})
export class DaterangeFormComponent implements DynamicForm, OnInit {

  @HostBinding('class')
  @Input() className = '';

  @Input() params: FormParams;

  dateStart = new FormControl('');
  dateEnd = new FormControl('');


  public datepickerConfig: Partial<BsDatepickerConfig> = {
    containerClass: 'theme-default',
    showWeekNumbers: false,
  };

  constructor() {
  }

  today = new Date();

  ngOnInit() {
    this.params.value = {
      start: null,
      end: null
    };

    this.dateStart.valueChanges.subscribe(date => {
      this.params.value.start = date;
    });

    this.dateEnd.valueChanges.subscribe(date => {
      this.params.value.end = date;
    });

    if (this.params.compactValue) {
      if (this.params.compactValue.start) {
        this.dateStart.setValue(moment(this.params.compactValue.start).toDate());
      }
      if (this.params.compactValue.end) {
        this.dateEnd.setValue(moment(this.params.compactValue.end).toDate());
      }
    }




  }


}
